import { jsx as _jsx } from "react/jsx-runtime";
export function LinkWithPreview({ href, children, className }) {
    return /*#__PURE__*/ _jsx("a", {
        href: href,
        className: className,
        target: "_blank",
        rel: "noopener noreferrer",
        children: children
    });
}
export default LinkWithPreview;
